export default __webpack_public_path__ + "static/media/activeCalendar.0fb70e6a.svg";